import React from 'react'
// libs
import { useDispatch } from 'react-redux'
// redux
import { hideModal as hideModalAction } from 'store/reducers/modals'
// hocs
import withAction from 'components/Modals/PlanItems/Action/withAction'
// hooks
import { useModalData } from 'hooks'
// components
import { Tab } from '@mui/material'
import { PlanActionActionsMenu } from 'components/CTAs'
import { LoaderWithOverlay, Tabs } from 'components/UI'
// view components
import ActionResourcesList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ResourcesList'
import ActionActivitiesList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ActivitiesList'
import ActionReviewsList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ReviewsList'
import CompleteAction from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/CompleteAction'
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
import ApproveReview from 'components/Modals/PlanItems/components/ApproveReview'
import DetailsSection from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection'
import FullModalContainer from '../../components/FullModalContainer'
// constants
import { Modals, ENTITIES } from 'constants/index'
// views
import {
  SubHeader,
  ContentWrapper,
  FlexScrollbar,
  FormWrapper,
  DetailsWrapper,
  FullModalHeader as Header,
  CollapseIcon,
  ActivitiesWrapper
} from 'components/Modals/PlanItems/styles'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { EllipsizedText } from 'themes/views/generic'
// context
import { ActionContext } from 'context'

const ActionFullModal = () => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { width, isOpen }
  } = useModalData({ modalType: Modals.ACTION_FULL_MODAL })

  const { entity, isLoading, plan, update } = React.useContext(ActionContext)

  const [tab, setTab] = React.useState(0)

  const handleClose = () => {
    dispatch(hideModalAction(Modals.ACTION_MINIMIZED_MODAL))
    dispatch(hideModalAction(Modals.ACTION_FULL_MODAL))
  }

  const handleSetTab = (_, value) => setTab(value)

  return (
    <FullModalContainer hideModal={hideModal} isOpen={isOpen} width={width}>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && (
        <>
          <Header>
            <EllipsizedText style={{ maxWidth: '95%' }}>{entity.description}</EllipsizedText>
            <CollapseIcon onClick={hideModal} />
            <CloseIcon onClick={handleClose} />
          </Header>
          <ContentWrapper>
            <FormWrapper>
              <CompleteAction isFullModal entity={entity} update={update} />
              <CompleteReview
                entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }}
                hideModal={hideModal}
                isFullModal
              />
              <ApproveReview
                entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }}
                hideModal={hideModal}
                isFullModal
              />
              <FlexScrollbar>
                <DetailsSection disableDrag hideModal={hideModal} isFullModal />
              </FlexScrollbar>
            </FormWrapper>
            <DetailsWrapper>
              <SubHeader>
                {!plan.locked && <PlanActionActionsMenu plan={plan} entity={entity} hideParent={hideModal} />}
                <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
                  <Tab label='Activity' />
                  <Tab label='Resources' />
                  <Tab label='Reviews' />
                </Tabs>
              </SubHeader>
              {tab === 0 && (
                <ActivitiesWrapper>
                  <ActionActivitiesList />
                </ActivitiesWrapper>
              )}
              {tab === 1 && <ActionResourcesList />}
              {tab === 2 && <ActionReviewsList />}
            </DetailsWrapper>
          </ContentWrapper>
        </>
      )}
    </FullModalContainer>
  )
}

export default withAction(ActionFullModal)
